import React from 'react';
import PropTypes from 'prop-types';

import SingleValueAndLabelBars from './SingleValueBar/SingleValueAndLabelBars';
import VerticalBarChart from './BarChart/VerticalBarChart';

import { humanizeNumber } from '../../../utils/format';
import { ESRI_YEAR_DEFAULTS } from '../../../constants';

const EducationCharts = ({ colors, overview: { education } }) => (
  <section>
    <h2 className="section-group-title">
      <span>Education</span>
    </h2>

    <div>
      <SingleValueAndLabelBars
        sectionTitle="Education Levels"
        colors={colors}
        data={[
          { label: 'Graduate Degree', value: humanizeNumber(education.educationGrad) },
          { label: 'Bachelor\'s Degree', value: humanizeNumber(education.educationBachelor) },
          { label: 'High School Diploma', value: humanizeNumber(education.educationHighSchool) },
        ]}
      />

      <VerticalBarChart
        sectionTitle={`Education Attainment ${ESRI_YEAR_DEFAULTS.currentYear}`}
        colors={colors}
        data={[
          { label: 'Graduate Degree', value: education.educationGrad },
          { label: 'Bachelor\'s Degree', value: education.educationBachelor },
          { label: 'Associates Degree', value: education.educationAssociates },
          { label: 'Some College', value: education.educationSomeCollege },
          { label: 'High School Diploma', value: education.educationHighSchool },
          { label: 'GED', value: education.educationGED },
          { label: 'No High School', value: education.educationNoHighSchool },
          { label: 'Some High School', value: education.educationSomeHighSchool },
        ]}
      />
    </div>
  </section>
);

EducationCharts.propTypes = {
  colors: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string]))
  .isRequired,
  overview: PropTypes.object.isRequired,
};

export default EducationCharts;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaOverview/EducationCharts.js